export interface GalleryUser {
  userId: number;
  name: string;
  userName: string;
  folderCount: number;
}

export interface GalleryFolder {
  folderId: string;
  name: string;
  syncedAt: string;
}

export interface GalleryPhotoLocationData {
  latitude: number;
  longitude: number;
  timestampISO: string;
  accuracy: number;
  altitudeAccuracy: number;
  altitude: number;
  speed: number;
  heading: number;
}

export interface GalleryPhotoDeviceData {
  deviceId: string;
  deviceModel: string;
  platform: string;
  osVersion: string;
  appVersion: string;
  userAgent: string;
  screenResolution: string;
  locale: string;
  timestampISO: string;
}

export interface GalleryPhotoSecurityData {
  hash: string;
  signature: string;
}

export interface GalleryPhoto {
  uuid: string;
  folderId: string;
  photoUrl: string;
  thumbnailUrl: string;
  mimeType: string;
  captureTimeIso: string;
  caption: string;
  locationData?: GalleryPhotoLocationData;
  deviceData?: GalleryPhotoDeviceData;
  securityData?: GalleryPhotoSecurityData;

  // client-side only (populated after downloading blobs)
  image?: string;
  thumbnailImage?: string;
  preferredRotation?: number;
}

export enum LoanInspectionType {
  DRAWS = 'DRAWS',
  INTERNAL_VALUATION = 'INTERNAL_VALUATION',
}

/**
 * An inspection of a loan, as listed when picking the destination of a photo copy.
 * externalId1 is always the loanId; externalId2 is the drawId for DRAWS inspections
 * and the propertyId for INTERNAL_VALUATION ones.
 */
export interface LoanInspectionSummary {
  inspectionId: number;
  inspectionType: LoanInspectionType;
  inspectionStatus: string;
  name: string;
  propertyAddress: string;
  externalId1: string;
  externalId2: string;
  drawNumber?: number;
  locked: boolean;
  /** Why the inspection is locked, null when it is still open. */
  lockedReason?: string;
  createdDate: string;
  lastUpdatedDate: string;
}

export interface GetGalleryUsersResponse {
  users: GalleryUser[];
}

export interface GetGalleryFoldersResponse {
  folders: GalleryFolder[];
}

export interface GetGalleryPhotosResponse {
  photos: GalleryPhoto[];
}

export interface CopyGalleryPhotosToInspectionResponse {
  photosCopied: number;
  inspectionId: number;
}
